import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAll() {
        try
        {            
            const response = await axios.get(`CompanyAnnouncements`,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })               
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getAll error')
            throw error
        }
    },
    async getCategories() {
        try
        {            
            const response = await axios.get(`CompanyAnnouncements/categories`,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getCategories error')
            throw error
        }
    },
    async upsert(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })      
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api upsert error')
            throw error
        }
    },
    async getNowShowing() {
        try
        {            
            //used in MyDasboard
            const response = await axios.get(`CompanyAnnouncements/now-showing`)              
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getNowShowing error')
            throw error
        }
    },
    async getById(companyAnnouncementId) {
        try
        {            
            const response = await axios.get(`CompanyAnnouncements/${companyAnnouncementId}`,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })               
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements api getById error')
            throw error
        }
    },
    async saveAttachment(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements/attachment/save`, data,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements saveAttachment api error')
            throw error
        }
    },
    async getAttachmentUrl(fileName) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements/attachment/pre-signed-url`,
            {
                fileName: fileName
            },
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements getAttachmentUrl api error')
            throw error
        }
    },
    async deleteAttachment(data) {
        try
        {            
            //HttpDelete requires add'l IIS setup
            const response = await axios.post(`CompanyAnnouncements/attachment/delete`, data,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements deleteAttachment api error')
            throw error
        }
    },
    async addRecipients(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements/recipients`, data,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements addRecipients api error')
            throw error
        }
    },
    async removeRecipient(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements/recipient/remove`, data,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements removeRecipient api error')
            throw error
        }
    },
    async addReaction(data) {
        try
        {            
            const response = await axios.post(`CompanyAnnouncements/reaction`, data,
            {
                headers: {
                    'page_key': pageKeys.company_announcements
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('CompanyAnnouncements addReaction api error')
            throw error
        }
    },
}